import { useState } from "react";
import { Rss, ShoppingBag, CalendarDays, Sparkles, Camera } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/context/I18nContext";

const ITEMS = [
  { key: "feed", icon: Rss },
  { key: "sell", icon: ShoppingBag },
  { key: "agenda", icon: CalendarDays },
  { key: "stories", icon: Sparkles },
  { key: "photos", icon: Camera },
];

export default function ArtistOnboardingGuide() {
  const { refresh } = useAuth();
  const { t } = useI18n();
  const [dismissing, setDismissing] = useState(false);

  const dismiss = async () => {
    setDismissing(true);
    try {
      await api.patch("/auth/me", { onboarding_seen: true });
    } catch (e) {
      // ignore — worst case the guide shows again next visit
    } finally {
      await refresh();
      setDismissing(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[60] bg-black/80 backdrop-blur-md grid place-items-center p-4" data-testid="onboarding-modal">
      <div className="relative w-full max-w-md max-h-[85dvh] bg-zinc-950 border border-white/10 rounded-3xl overflow-hidden anim-in flex flex-col">
        <div className="p-6 pb-0 overflow-y-auto">
          <h2 className="text-2xl font-black font-display text-white">{t.onboarding.title}</h2>
          <p className="mt-2 text-sm text-zinc-400">{t.onboarding.intro}</p>

          <ul className="mt-5 space-y-3">
            {ITEMS.map(({ key, icon: Icon }) => (
              <li key={key} className="flex items-start gap-3 bg-zinc-900/70 rounded-2xl p-3 border border-white/5">
                <div className="shrink-0 w-8 h-8 grid place-items-center rounded-full bg-gradient-to-br from-[#FF0050] to-[#8A2BE2]">
                  <Icon className="w-4 h-4 text-white" />
                </div>
                <p className="text-sm text-zinc-200">{t.onboarding[key]}</p>
              </li>
            ))}
          </ul>
        </div>

        <div className="p-6 pt-4 shrink-0">
          <button
            onClick={dismiss}
            disabled={dismissing}
            className="btn-primary w-full"
            data-testid="onboarding-dismiss"
          >
            {t.onboarding.cta}
          </button>
        </div>
      </div>
    </div>
  );
}
